import { render, staticRenderFns } from "./KheopsClipLoader.vue?vue&type=template&id=cfd08720&"
import script from "./KheopsClipLoader.vue?vue&type=script&lang=js&"
export * from "./KheopsClipLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports